import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Mode} from '../models/mode';

@Injectable({
    providedIn: 'root'
})
export class ProjectReferenceViewModeService {
    mode$ = new BehaviorSubject<Mode>(Mode.Read);

    setReadMode() {
        this.mode$.next(Mode.Read);
    }

    setEditMode() {
        this.mode$.next(Mode.Edit);
    }
}
